import { enhancedApi as postgridApi } from './generated/postgridService';

// Re-export types from the generated service
export type {
  BlobSchema,
  ChequeMailableItem,
  CreatePostgridCheque,
  CreatePostgridContact,
  CreatePostgridLetter,
  ExtractedRecipientInfo,
  ExtractRecipientRequest,
  ExtractRecipientResponse,
  LetterMailableItem,
  PostGridMailingClass,
  PostGridObjectStatus,
  PostgridAttachmentsAddToChequeApiArg,
  PostgridAttachmentsAddToChequeApiResponse,
  PostgridAttachmentsAddToLetterApiArg,
  PostgridAttachmentsAddToLetterApiResponse,
  PostgridAttachmentsDestroyApiArg,
  PostgridAttachmentsDestroyApiResponse,
  PostgridAttachmentsListApiArg,
  PostgridAttachmentsListApiResponse,
  PostgridChequesCancelApiArg,
  PostgridChequesCancelApiResponse,
  PostgridChequesCreateApiArg,
  PostgridChequesCreateApiResponse,
  PostgridChequesDetailedApiArg,
  PostgridChequesDetailedApiResponse,
  PostgridChequesListApiArg,
  PostgridChequesListApiResponse,
  PostgridChequesProgressTestApiArg,
  PostgridChequesProgressTestApiResponse,
  PostgridChequesRetrieveApiArg,
  PostgridChequesRetrieveApiResponse,
  PostgridContactsCreateApiArg,
  PostgridContactsCreateApiResponse,
  PostgridContactsDestroyApiArg,
  PostgridContactsDestroyApiResponse,
  PostgridContactsListApiArg,
  PostgridContactsListApiResponse,
  PostgridContactsRetrieveApiArg,
  PostgridContactsRetrieveApiResponse,
  PostgridEventsListApiArg,
  PostgridEventsListApiResponse,
  PostgridLettersCancelApiArg,
  PostgridLettersCancelApiResponse,
  PostgridLettersCreateApiArg,
  PostgridLettersCreateApiResponse,
  PostgridLettersDetailedApiArg,
  PostgridLettersDetailedApiResponse,
  PostgridLettersExtractRecipientApiArg,
  PostgridLettersExtractRecipientApiResponse,
  PostgridLettersListApiArg,
  PostgridLettersListApiResponse,
  PostgridLettersProgressTestApiArg,
  PostgridLettersProgressTestApiResponse,
  PostgridLettersRetrieveApiArg,
  PostgridLettersRetrieveApiResponse,
  PostgridMailablesListApiArg,
  PostgridMailablesListApiResponse,
  ReadDetailedPostgridCheque,
  ReadDetailedPostgridLetter,
  ReadPostgridAttachment,
  ReadPostgridCheque,
  ReadPostgridContact,
  ReadPostgridEvent,
  ReadPostgridLetter,
  UpdatePostgridContact,
} from './generated/postgridService';

// Export all hooks from the generated service
export const {
  usePostgridContactsListQuery,
  usePostgridContactsCreateMutation,
  usePostgridContactsDestroyMutation,
  usePostgridContactsRetrieveQuery,
  usePostgridContactsUpdateMutation,
  usePostgridContactsRetrySyncMutation,
  usePostgridContactsByPoliceChannelQuery,
  usePostgridContactsUnsyncedQuery,
  usePostgridChequesCreateMutation,
  usePostgridChequesCancelMutation,
  usePostgridChequesProgressTestMutation,
  usePostgridChequesRetrieveQuery,
  usePostgridChequesDetailedQuery,
  usePostgridChequesListQuery,
  usePostgridChequesRetrySendMutation,
  usePostgridChequesUnsyncedQuery,
  usePostgridLettersCreateMutation,
  usePostgridLettersCancelMutation,
  usePostgridLettersProgressTestMutation,
  usePostgridLettersListQuery,
  usePostgridLettersRetrieveQuery,
  usePostgridLettersDetailedQuery,
  usePostgridLettersRetrySendMutation,
  usePostgridLettersExtractRecipientMutation,
  usePostgridLettersUnsyncedQuery,
  usePostgridAttachmentsListQuery,
  usePostgridAttachmentsRetrieveQuery,
  usePostgridAttachmentsDestroyMutation,
  usePostgridAttachmentsAddToChequeMutation,
  usePostgridAttachmentsAddToLetterMutation,
  usePostgridAttachmentsClearChequeAttachmentsMutation,
  usePostgridAttachmentsClearLetterAttachmentsMutation,
  usePostgridEventsListQuery,
  usePostgridEventsRetrieveQuery,
  usePostgridMailablesListQuery,
} = postgridApi;

// Additional friendly aliases expected by existing components
// Keep using the same implementation underneath so there is no extra overhead
export const useGetChequeQuery = (
  chequeId: string,
  options?: Parameters<typeof postgridApi.usePostgridChequesRetrieveQuery>[1],
) => postgridApi.usePostgridChequesRetrieveQuery({ id: chequeId }, options);

export const useGetLetterQuery = (
  letterId: string,
  options?: Parameters<typeof postgridApi.usePostgridLettersRetrieveQuery>[1],
) => postgridApi.usePostgridLettersRetrieveQuery({ id: letterId }, options);

export const useGetChequeDetailedQuery = (
  chequeId: string,
  options?: Parameters<typeof postgridApi.usePostgridChequesDetailedQuery>[1],
) => postgridApi.usePostgridChequesDetailedQuery({ id: chequeId }, options);

export const useGetLetterDetailedQuery = (
  letterId: string,
  options?: Parameters<typeof postgridApi.usePostgridLettersDetailedQuery>[1],
) => postgridApi.usePostgridLettersDetailedQuery({ id: letterId }, options);

export const useListLettersQuery = (
  params: Parameters<typeof postgridApi.usePostgridLettersListQuery>[0],
  options?: Parameters<typeof postgridApi.usePostgridLettersListQuery>[1],
) => postgridApi.usePostgridLettersListQuery(params, options);

export const useListEventsQuery = (
  params: Parameters<typeof postgridApi.usePostgridEventsListQuery>[0],
  options?: Parameters<typeof postgridApi.usePostgridEventsListQuery>[1],
) => postgridApi.usePostgridEventsListQuery(params, options);

export const useCreatePostgridChequeMutation =
  postgridApi.usePostgridChequesCreateMutation;
export const useCreatePostgridLetterMutation =
  postgridApi.usePostgridLettersCreateMutation;
export const useListAttachmentsQuery = (
  params: Parameters<typeof postgridApi.usePostgridAttachmentsListQuery>[0],
  options?: Parameters<typeof postgridApi.usePostgridAttachmentsListQuery>[1],
) => postgridApi.usePostgridAttachmentsListQuery(params, options);
export const useCreateLetterMutation =
  postgridApi.usePostgridLettersCreateMutation;
